import { BaseAPI } from "@utils/base-api";
import { SerialType } from "@utils/types";
import { AxiosHeaders } from "axios";

import {
  CATS_CUSTOMER_UPDATE_DETAILS_PATH,
  CATS_CUSTOMER_GET_ALL_PATH,
} from "./constants/endpoints/customer";
import {
  IUpdateCatDetailsRequest,
  IUpdateCatDetailsResponse,
} from "./types/update-cat.types";
import {
  IGetCustomerCatsResponse,
  SubscriptionFilter,
} from "./types/cat-info.types";

export class CatsAPI extends BaseAPI {

  public async getCats({
    filterSubscription,
    showSuppressedCats,
    headers,
  }: {
    headers?: AxiosHeaders,
    filterSubscription?: SubscriptionFilter,
    showSuppressedCats?: boolean,
  }): Promise<IGetCustomerCatsResponse> {
    return this.getWithTransform<IGetCustomerCatsResponse>(
      CATS_CUSTOMER_GET_ALL_PATH,
      {
        params: {
          showSuppressedCats,
          filterSubscription,
        },
        headers,
      },
      {
        dateFields: [
          "birthday",
        ],
      },
    );
  }

  /**
   * Updates the cat details for a customer.
   *
   * @param data - The data to update the cat details with.
   * All data except id is optional and nullable.
   * @returns The full cat details after the update.
   */
  public async updateCatDetails(data: IUpdateCatDetailsRequest): Promise<SerialType<IUpdateCatDetailsResponse>> {
    const result = await this.axios.patch(
      CATS_CUSTOMER_UPDATE_DETAILS_PATH,
      data,
    );

    return result.data;
  }

}
